import _ from 'lodash';
import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-current-last-hero-option',
  templateUrl: './current-last-hero-option.component.html',
  styleUrls: ['./current-last-hero-option.component.scss']
})
export class CurrentLastHeroOptionComponent implements OnChanges  {
  @Input() campaign: any = null;
  @Input() option: any = null;
  @Input() event: any = null;
  @Input() raised: any = 0;
  @Input() list: any[] = [];

  public status: any = null;
  public winner: any = null;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    const campaign = _.get(changes, 'campaign.currentValue', this.campaign);
    const list = _.get(changes, 'list.currentValue', this.list);
    const result = _.find(list, { id: campaign.id });

    this.winner = _.get(result, 'campaignTypeData.winnerUser', null);
  }

  isNotEmpty(campaign) {
    return !_.isEmpty(campaign);
  }

  getImageUrl(option) {
    return option.imageUrl === '' ? '/images/org_logo_default_v2.svg' : option.imageUrl;
  }
}
